/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnalyticsGoals } from './AnalyticsGoals';
import {
    AnalyticsGoalsFromJSON,
    AnalyticsGoalsFromJSONTyped,
    AnalyticsGoalsToJSON,
} from './AnalyticsGoals';

/**
 * Matomo web analytics. Enables client-side page/visit tracking and server-side goal conversions. Every value here is specific to one Matomo instance, so a tenant with its own Matomo configures its own server URL, site id and goal ids. Off when absent; the API auth token stays in server config (MATOMO_API_KEY), never in tenant data.
 * @export
 * @interface AnalyticsModule
 */
export interface AnalyticsModule {
    /**
     * 
     * @type {boolean}
     * @memberof AnalyticsModule
     */
    enabled?: boolean;
    /**
     * Matomo server base URL, e.g. https://analytics.example.com/ (trailing slash optional).
     * @type {string}
     * @memberof AnalyticsModule
     */
    url?: string;
    /**
     * Matomo site id this tenant reports into.
     * @type {string}
     * @memberof AnalyticsModule
     */
    site_id?: string;
    /**
     * Path of the tracking endpoint relative to the server URL. Stock Matomo serves 'matomo.php' (the default); instances that obfuscate it (Care&'s serves 'rainbow') set their own.
     * @type {string}
     * @memberof AnalyticsModule
     */
    tracker_path?: string;
    /**
     * Path of the tracking JavaScript relative to the server URL. Stock Matomo serves 'matomo.js' (the default); Care&'s serves 'unicorn'.
     * @type {string}
     * @memberof AnalyticsModule
     */
    script_path?: string;
    /**
     * 
     * @type {AnalyticsGoals}
     * @memberof AnalyticsModule
     */
    goals?: AnalyticsGoals;
}

/**
 * Check if a given object implements the AnalyticsModule interface.
 */
export function instanceOfAnalyticsModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnalyticsModuleFromJSON(json: any): AnalyticsModule {
    return AnalyticsModuleFromJSONTyped(json, false);
}

export function AnalyticsModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'site_id': !exists(json, 'site_id') ? undefined : json['site_id'],
        'tracker_path': !exists(json, 'tracker_path') ? undefined : json['tracker_path'],
        'script_path': !exists(json, 'script_path') ? undefined : json['script_path'],
        'goals': !exists(json, 'goals') ? undefined : AnalyticsGoalsFromJSON(json['goals']),
    };
}

export function AnalyticsModuleToJSON(value?: AnalyticsModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'url': value.url,
        'site_id': value.site_id,
        'tracker_path': value.tracker_path,
        'script_path': value.script_path,
        'goals': AnalyticsGoalsToJSON(value.goals),
    };
}

